import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function TermsModal({ open, onAccept }) {
  const [checked, setChecked] = useState(false);
const isMobile = window.innerWidth < 640;
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) return null;

  const handleAccept = () => {
    if (!checked) return;
    onAccept?.();
  };

  return createPortal(
    <div
    //   style={{
    //     position: "fixed",
    //     inset: 0,
    //     zIndex: 9999,
    //     backgroundColor: "rgba(0,0,0,0.65)",
    //     overflowY: "auto",
    //     padding: "24px 16px",
    //   }}
    style={{
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    backgroundColor: "rgba(0,0,0,0.65)",
    display: "flex",
    justifyContent: "center",
    alignItems: isMobile ? "flex-end" : "center",
  }}
      onMouseDown={(e) => {
        // prevent accidental closing by clicking outside
        e.stopPropagation();
      }}
    >
      <div
        // style={{
        //   minHeight: "100%",
        //   display: "flex",
        //   justifyContent: "center",
        //   alignItems: "flex-start",
        // }}
        style={{
      width: isMobile ? "90%" : "900px",
      height: isMobile ? "85vh" : "auto",
      borderTopLeftRadius: isMobile ? "16px" : "16px",
      borderTopRightRadius: isMobile ? "16px" : "16px",
      borderRadius: isMobile ? "16px 16px 0 0" : "16px",
      background: "#fff",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    }}
      >
        <div
          style={{
            width: "min(900px, 100%)",
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
            maxHeight: "calc(100vh - 48px)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div
            style={{
              padding: "24px",
              overflowY: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <h2 style={{ fontSize: "24px", fontWeight: "700", margin: 0 }} className="text-center">
              Consumer Connect Survey Terms &amp; Conditions
            </h2>

            <div style={{ marginTop: "18px", lineHeight: "1.8", fontSize: "14px", color: "#333" }}>
             
              <p>
                Barah-e-karam apne jawab imaandari aur ghour se dein. Consumer Connect sirf un logon ko rewards deta hai jinki responses quality standards par poori utarti hain. Is mein consistency (jo information aap ne sign-up ke waqt di), ek hi valid aur unique email/account ki verification, aur genuine, soch samajh kar diya gaya feedback shamil hai. Duplicate, misleading, inconsistent, jaldi mein diye gaye ya low quality responses rewards ke liye eligible nahi honge. Tamam participant data ko zimmedari ke sath handle kiya jata hai, privacy aur ethical research standards ke mutabiq, jisme GDPR aur ESOMAR principles bhi shamil hain jahan applicable ho.
              </p>

              <h3 style={{ fontSize: "18px", marginBottom: "8px", marginTop: "18px" }}>
                Participation Terms &amp; Conditions
              </h3>
              <p>Consumer Connect survey mein hissa le kar aap in baaton se ittefaq karte hain:</p>

              <p><strong>1. Honest aur Thoughtful Participation</strong></p>
              <p>
                Participants se expect kiya jata hai ke wo apni asal raaye aur tajurbe ki bunyaad par sachay aur soch samajh kar jawab dein. Be-parwai se, jhoot par mabni, ya sirf reward hasil karne ke liye diye gaye jawab review ho kar disqualify kiye ja sakte hain.
              </p>

              <p><strong>2. Voluntary Participation</strong></p>
              <p>
                Consumer Connect surveys mein hissa lena bilkul voluntary hai.
                Aap kisi bhi waqt survey chhor sakte hain.
              </p>

              <p><strong>3. Reward Eligibility</strong></p>
              <p>
                Rewards sirf un participants ko diye jayenge jinki responses
                quality aur verification standards par poori utarti hain. Is mein shamil hai:
              </p>
              <ul>
                <li>sign-up ke waqt di gayi maloomat ke sath consistency</li>
                <li>wahi valid aur unique email/account ka use jo registration ke waqt use hua</li>
                <li>genuine, thoughtful aur relevant feedback</li>
                <li>survey ke quality aur authenticity checks ka successful completion</li>
              </ul>
              <p>
                Consumer Connect ko yeh haq hasil hai ke agar yeh standards poore na hon to rewards rok liye ya cancel kiye ja sakte hain.
              </p>

              <p><strong>4. Data Quality aur Verification Checks</strong></p>
              <p>
                Research ki integrity barqarar rakhne ke liye, Consumer Connect responses ko completeness, consistency, duplication, suspicious activity, fraud ya registration details se mismatch ke liye check kar sakta hai. Jo responses in checks par poori na utrein, unhein analysis aur rewards se exclude kiya ja sakta hai.
              </p>

              <p><strong>5. Use of Responses</strong></p>
              <p>
                Participants ki di gayi maloomat sirf market research, consumer insights aur related analysis ke liye use hogi. Responses ko individual level par quality ke liye check kiya ja sakta hai aur aggregate ya anonymized form mein analyze kiya jata hai taake products, services aur decision-making ko behtar banaya ja sake.
              </p>

              <p><strong>6. Privacy aur Confidentiality</strong></p>
              <p>
                Consumer Connect participant ki privacy ka ehtram karta hai. Agar personal data collect kiya jaye to confidential rakha jata hai aur direct marketing ke liye third parties ke sath share ya sell nahi kiya jata.
              </p>

              <p><strong>7. Research Standards aur Data Protection</strong></p>
              <p>
                Consumer Connect data ko zimmedari ke sath handle karta hai aur research ko applicable privacy, data protection aur ethical standards ke mutabiq conduct karta hai, jisme GDPR aur ESOMAR principles shamil hain jahan relevant ho.
              </p>

              <p><strong>8. Follow-up Contact</strong></p>
              <p>
                Kuch cases mein participants se unke responses ki clarification,
                validation ya additional research opportunities ke liye contact
                kiya ja sakta hai.
              </p>

              <p><strong>9. Acceptance of Terms</strong></p>
              <p>
                Survey continue karne se aap tasdeeq karte hain ke aap ne in terms ko parh liya hai, samajh liya hai aur in se ittefaq karte hain.
              </p>
            </div>

            <div
              style={{
                marginTop: "20px",
                padding: "16px",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                background: "#f9fafb",
              }}
            >
              <label style={{ display: "flex", gap: "10px", alignItems: "flex-start", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                  style={{ marginTop: "4px" }}
                />
                <span style={{ fontSize: "15px", color: "#005FA7" }}>I accept the terms and conditions</span>
              </label>
            </div>

            <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={handleAccept}
                disabled={!checked}
                style={{
                  padding: "12px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: checked ? "#111827" : "#9ca3af",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: checked ? "pointer" : "not-allowed",
                }}
              >
                Accept and Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}